/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Complete_ToastInputs */



/**
* | output |
* | --- |
* | "OCR analysis complete." |
*
* @param {Ocr_Complete_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_complete_toast = /** @type {((inputs?: Ocr_Complete_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Complete_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Analyse OCR terminée.")
	if (locale === "de") return /** @type {LocalizedString} */ ("OCR-Analyse abgeschlossen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Analisi OCR completata.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Анализ OCR завершен.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Análisis OCR completado.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("OCR分析完成。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("OCR分析が完了しました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ओसीआर विश्लेषण पूर्ण हो गया।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Análise OCR concluída.")
	return /** @type {LocalizedString} */ ("OCR analysis complete.")
});